import Layout from '@/layout'
import Father from '@/layout/father'
// import router from '.'

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*', redirect: '/404', hidden: true
}

/**
 * 动态生成菜单
 * @param param
 * @returns {Promise<Router>}
 */
export const generatorDynamicRouter = (param) => {
  // 从缓存中读取侧边栏信息
  if (localStorage.getItem('navBar')) {
    const navBar = JSON.parse(localStorage.getItem('navBar'))
    // 路由结构重组
    const routers = generator(navBar)
    routers.push(notFoundRouter)
    return routers
  } else {
    return false
  }
}

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  // 按照数据定义参数--如果有
  routerMap = routerMap.filter(item => {
    return item.path && item.component && item.name
  })
  return routerMap.map(item => {
    const { title, show, noCache, icon, id, handler } = item || {}
    const currentRouter = {
      // 路由path
      path: item.path,
      // 路由名称，唯一值
      name: item.name || '',
      // 该路由对应页面的 组件 第一级使用Layout布局 children中按需引入
      component: item.component === 'Layout' ? Layout
        : item.component === 'Father' ? Father
          : item.component ? resolve => require(['@/views/' + item.component.replace(/^\//, '') + '.vue'], resolve) : '',
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: title,
        icon: icon || undefined,
        noCache: noCache || true,
        id: id, // 根据实际定义
        handler: handler
      }
    }
    // 动态生成redirect，拼接自身path和第一个show:true的children的path
    if (item.redirect && item.children && item.children.length > 0) {
      currentRouter.redirect = item.path + '/' + item.children.filter(item => { return item.show })[0].path
    }
    // 是否隐藏菜单
    if (show === false) {
      currentRouter.hidden = true
    }
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    if (!currentRouter.path.startsWith('http')) {
      currentRouter.path = currentRouter.path.replace('//', '/')
    }
    // 重定向
    // item.redirect && (currentRouter.redirect = item.redirect)
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // 递归
      currentRouter.children = generator(item.children, currentRouter)
    }
    return currentRouter
  })
}
